'use client';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

const StyledSwipeableDrawer = styled(SwipeableDrawer, {
    shouldForwardProp: prop => prop !== 'drawerHeight',
    /* @ts-ignore */
})(({ drawerHeight }) => ({
    '& .MuiPaper-root': {
        width: '100vw',
        maxHeight: '100%',
        height: drawerHeight ? drawerHeight : 'auto',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        overflow: 'auto',
    },
    '& .MuiBackdrop-root': {
        backdropFilter: 'blur(3px)',
    },
}));

const BottomSheetNoPadding: React.FC<{
    children: React.ReactElement[] | React.ReactElement;
    open: boolean;
    setOpen?: (flag: boolean) => void;
    heightInput?: string;
    onOpen?: () => void;
    onClose?: () => void;
    className?: any;
    drawerHeight?: string;
}> = ({
    children,
    open,
    setOpen,
    onClose,
    onOpen,
    className,
    drawerHeight,
}) => {
    const toggleDrawer = (newOpen: boolean) => () => {
        if (!newOpen && onClose) {
            onClose();
        }
        if (newOpen && onOpen) {
            onOpen();
        }
        if (setOpen) setOpen(newOpen);
    };

    return (
        <Box
            sx={{
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(0,0,30,0.4)',
            }}
        >
            {/* @ts-ignore */}
            <StyledSwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={0}
                disableSwipeToOpen={true}
                disableBackdropTransition
                ModalProps={{
                    keepMounted: true,
                }}
                /* @ts-ignore */
                drawerHeight={drawerHeight}
            >
                <StyledBox
                    sx={{
                        height: '100%',
                    }}
                    className={`${className}`}
                >
                    <>{children}</>
                </StyledBox>
            </StyledSwipeableDrawer>
        </Box>
    );
};
export default BottomSheetNoPadding;
// 'use client';

// import React, { useEffect, useState } from 'react';
// import { createPortal } from 'react-dom';

// const BottomSheetNoPadding: React.FC<{
//     children: React.ReactElement[] | React.ReactElement;
//     open: boolean;
//     setOpen?: (flag: boolean) => void;
//     onOpen?: () => void;
//     onClose?: () => void;
//     className?: string;
//     drawerHeight?: string;
// }> = ({
//     children,
//     open,
//     setOpen,
//     onClose,
//     onOpen,
//     className,
//     drawerHeight,
// }) => {
//     const [isTransitioning, setIsTransitioning] = useState(false);
//     const [startY, setStartY] = useState<number | null>(null);

//     const handleClose = () => {
//         setTimeout(() => {
//             if (setOpen) setOpen(false);
//         }, 300); // Duration of the animation

//         if (onClose) onClose();
//     };

//     const handleOpen = () => {
//         setIsTransitioning(false);
//         if (onOpen) onOpen();
//     };

//     useEffect(() => {
//         if (open) {
//             document.body.style.overflow = 'hidden';
//             handleOpen();
//         } else {
//             document.body.style.overflow = '';
//         }
//     }, [open]);

//     const handleTouchStart = (e: React.TouchEvent) => {
//         setStartY(e.touches[0].clientY);
//     };

//     const handleTouchMove = (e: React.TouchEvent) => {
//         if (startY === null) return;
//         const currentY = e.touches[0].clientY;
//         const deltaY = currentY - (startY || 0);
//         if (deltaY > 100) {
//             // Swipe down threshold
//             handleClose();
//         }
//     };

//     const handleTouchEnd = () => {
//         setStartY(null);
//     };

//     if (!open && isTransitioning) return null;

//     return createPortal(
//         <div
//             className={`fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-end transition-transform duration-500  ${
//                 open ? 'opacity-100 z-50' : 'opacity-0'
//             }`}
//             onClick={handleClose}
//         >
//             <div
//                 className={`w-full max-h-full ${
//                     drawerHeight ? drawerHeight : 'auto'
//                 } bg-white dark:bg-gray-800 rounded-t-lg overflow-auto transform transition-transform duration-500 ${
//                     open ? 'translate-y-0' : 'translate-y-full'
//                 }`}
//                 onClick={e => e.stopPropagation()}
//                 onTouchStart={handleTouchStart}
//                 onTouchMove={handleTouchMove}
//                 onTouchEnd={handleTouchEnd}
//             >
//                 <div className={`h-full ${className}`}>{children}</div>
//             </div>
//         </div>,
//         document.body
//     );
// };

// export default BottomSheetNoPadding;
